export default __webpack_public_path__ + "static/media/logo-factura.a871ad2b.jpg";